import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useUser } from './UserContext';
import Login from './Login';
import Register from './Register';
import Dashboard from './Dashboard';
import PatientActivation from './patient-activation';
import SetPassword from './SetPassword';
import Translate from './Translate';
import Scanner from './Orders/Scanner.js';
import Filetransfer from './filetransfer/Filetransfer.js';
import PrivacyPolicy from './PrivacyPolicy';
import LandingPage from './LandingPage';
import OncoriskDashboard from './PlatformTools/Oncology/OncologyLanding';
import GeneriskDashboard from './PlatformTools/Generiskpro/GRLanding';
import ReportView from './ReportViewer/ReportView';
import { UserProvider } from './UserContext';
import OncoRisk from './WebServer/OncoRisk/oncorisk.js';
import NewGenome from './WebServer/NewGenome/NewGenome.js';
import UltimateHome from './UltimateHome/UltimateHome.js';

function App() {
    return (
        <UserProvider>
            <Router>
                <Routes>
                {/* Public routes */}
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/oncorisk" element={<OncoRisk />} />
                <Route path="/varxomics" element={<NewGenome />} />
                <Route path="/generiskpro" element={<GeneriskDashboard />} />
                <Route path="/babygenepro" element={<GeneriskDashboard />} />
                <Route path="/report/:uuid" element={<ReportView />} />
                <Route path="/set-password" element={<SetPassword />} />
                <Route path="/ult" element={<UltimateHome />} />

                {/* Protected routes */}
                <Route path="/dashboard" element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                } />
                <Route path="/filetransfer1" element={
                    <ProtectedRoute>
                        <Filetransfer />
                    </ProtectedRoute>
                } />
                <Route path="/translate/:lang" element={<Translate />} />
                <Route path="/ScanEx" element={<Scanner />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                {/* Add any other protected routes here */}
                </Routes>
            </Router>
        </UserProvider>
    );
}

const ProtectedRoute = ({ children }) => {
    const { user, isLoadingUser } = useUser();
    const token = Cookies.get('token');
    
    // Wait if user data is still loading
    if (isLoadingUser) {
        // Optionally, return a loading spinner here instead of null
        return null; 
    }

    // Check both user state from context and token cookie after loading is complete
    if (!user || !token) {
        console.log('[ProtectedRoute] Redirecting to login. User state exists:', !!user, 'Token exists:', !!token);
        return <Navigate to="/login" />;
    }
    
    return children;
};

export default App;